<template>
  <Loader v-if="loading" />
  <div class="flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">Convalida modifiche contratti</h4>
    <Button
      icon="pi pi-search"
      label="Modifiche approvate"
      class="p-button-rounded p-button-secondary"
      @click="openApprovedChangesDialog"
    />
  </div>
  <div v-if="loaded">
    <div v-if="!has_items">
      <div class="card">Non ci sono modifiche da validare</div>
    </div>
    <div v-else class="card" v-for="(item, i) in items" :key=i style="min-width:380px">
      <h4>Modifiche caricamento #{{i}} da {{item.agente ?? item.admin}} ({{item.agente ? 'agente' : 'admin'}}) del {{ moment(item.data).format('D-M-YYYY') }}</h4>
      <div class="flex">
        <!-- Blocco 1 -->
        <div class="col-5 flex flex-column align-items-start">
          <h5 class="col-12 flex">Dati attuali</h5>
          <div v-for="(modifica,id) in item.modifiche" :key="id" class="col-12 flex flex-column justify-content-center align-items-start bg-attuale change-box" style="margin:7px 0 7px -7px;">
            <div v-if="typeof modifica.old_setted == 'object'" class="flex">
              <div class="flex align-items-center m-1">
                <p class="bg-attuale-change">{{modifica.label_modifica}}: </p>  
              </div>
              <div class="flex flex-column m-1">
                <div v-for="(el, key) in modifica.old_setted" :key="key" class="w-full">
                  <p :class="[el.is_changed ? 'bg-attuale-change' : '']">{{ key.replace('_', ' ') }}: <strong>{{el.value}}</strong></p>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="bg-attuale-change">{{modifica.label_modifica}}: <strong>{{modifica.old_setted}}</strong></p>
            </div>
          </div>
        </div>
        <!-- Blocco Accetta -->
        <div class="col-2 flex flex-column align-items-center justify-content-center">
          <h5 class="col-12 flex justify-content-center">Accetta</h5>
          <div v-for="(modifica,id) in item.modifiche" :key="id" class="col-12 flex justify-content-center align-items-center m-2 change-box">
            <Checkbox v-model="modifica.accept" :binary="true" @change="checkIsAccepted($event, i)" :disabled="modifica.disabled"/>
          </div>
        </div>
        <!-- Blocco 2 -->
        <div class="col-5 flex flex-column align-self-center">
          <h5 class="col-12 flex justify-content-end">Modifiche richieste</h5>
          <div v-for="(modifica,id) in item.modifiche" :key="id" class="col-12 flex flex-column align-items-end justify-content-center bg-modifica m-2 change-box">
            <div v-if="typeof modifica.new_setted == 'object'" class="flex">
              <div class="flex align-items-center m-1">
                <p class="bg-modifica-change">{{modifica.label_modifica}}: </p>  
              </div>
              <div class="flex flex-column m-1">
                <div v-for="(el, key) in modifica.new_setted" :key="key" class="w-full">
                  <p :class="[el.is_changed ? 'bg-modifica-change' : '']">{{ key.replace('_',' ') }}: <strong>{{el.value}}</strong></p>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="modifica.request_delete">
                <p class="bg-modifica-change">{{ modifica.label_delete }}</p>
              </div>
              <div v-else class="flex flex-column align-items-end">
                <p class="bg-modifica-change">{{modifica.label_modifica}}: <strong>{{modifica.new_setted}}</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 flex justify-content-center">
        <div class="col-6 flex justify-content-between align-items-center" style="height:50px">
          <Button :disabled="!item.is_accepted" label="Invia modifiche" class="p-button-rounded p-button-success" @click="sendValidation(i, item.modifiche)"/>
          <Button :disabled="item.is_accepted" label="Elimina modifiche" class="p-button-rounded p-button-danger" @click="sendValidation(i, item.modifiche, true)"/>
        </div>
      </div>
    </div>
  </div> 
  <Dialog
    v-model:visible="showApprovedChangesDialog"
    modal
    header="Modifiche approvate"
    :style="{ width: '80vw' }"
    :closable="true"
  >
    <Loader v-if="approvedLoading" />
    <div v-else>
      <div class="approved-search">
        <InputText
          v-model="approvedSearch"
          class="w-full"
          placeholder="Cerca per tipo, valore o ID matrice"
          @input="onApprovedSearchInput"
          @keydown.enter="searchApprovedChanges"
        />
        <Button v-if="approvedSearch.trim().length >= 3" icon="pi pi-search" label="Cerca" @click="searchApprovedChanges" />
      </div>
      <div v-if="!approvedHasItems" class="card">Non ci sono modifiche approvate da mostrare</div>
      <div v-else class="approved-list">
        <div v-for="item in approvedItems" :key="item.id_matrice" class="card approved-card">
          <h4 class="approved-title">
            Modifiche caricamento #{{ item.id_matrice }}
            <span v-if="item.admin"> da {{ item.admin }} (admin)</span>
            <span v-if="item.data"> del {{ formatApprovedDate(item.data, 'D-M-YYYY') }}</span>
          </h4>
          <div class="approved-meta">
            <span>Validator ID: {{ item.admin_id_validator }}</span>
            <span v-if="item.validator_nome || item.validator_cognome">
              Approvata da: {{ [item.validator_nome, item.validator_cognome].filter(Boolean).join(' ') }}
            </span>
          </div>
          <div class="approved-columns-header">
            <div>Dati precedenti</div>
            <div>Modifica</div>
            <div>Modifiche approvate</div>
          </div>
          <div
            v-for="modifica in item.modifiche"
            :key="modifica.id"
            :class="['approved-layout-row', { 'approved-delete-row': modifica.type_modifica === 'delete' }]"
          >
            <div class="approved-panel approved-old">
              <pre class="approved-value">{{ formatApprovedValue(modifica.old) }}</pre>
            </div>
            <div class="approved-center">
              <strong>{{ getApprovedChangeLabel(modifica) }}</strong>
              <small>{{ formatApprovedDate(modifica.data_aggiornamento) }}</small>
            </div>
            <div v-if="modifica.type_modifica !== 'delete' && getApprovedChangeLabel(modifica) !== 'Eliminazione iban'" class="approved-panel approved-new">
              <pre class="approved-value">{{ formatApprovedValue(modifica.new) }}</pre>
            </div>
            <div v-else class="approved-empty-panel"></div>
          </div>
        </div>
      </div>
      <Paginator
        v-if="approvedTotal > approvedPerPage"
        :first="(approvedCurrentPage - 1) * approvedPerPage"
        :rows="approvedPerPage"
        :totalRecords="approvedTotal"
        @page="onApprovedPage"
      />
    </div>
  </Dialog>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars
import moment from 'moment'
import {ref, onMounted, getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Loader from "@/components/Loader.vue"
import { useToast } from 'primevue/usetoast';
import { useRoute, useRouter } from 'vue-router'
import roles from '@/config/roles'

export default {
  components: {
    Loader
  },  
  setup () {
    const route = useRoute()
    const router = useRouter()
    const toast = useToast();
    const store = useStore()
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const loading = ref(false)
    const loaded = ref(false)
    const currentUser = ref(store.state.auth.user)
    const items = ref();
    const approvedItems = ref([])
    const approvedLoading = ref(false)
    const showApprovedChangesDialog = ref(false)
    const approvedSearch = ref('')
    const approvedTotal = ref(0)
    const approvedPerPage = ref(10)
    const approvedCurrentPage = ref(1)
    const validationErrors = ref({})
    const submitted = ref(false)
    const layout = ref('list');
    const has_items = ref()
    const types_modifica = ref({
      delete: {label: 'Fornitura', props:[], label_delete: 'Fornitura da eliminare'},
      periodo_ft_contratto: {label: 'Periodo di fatturazione', props:[], label_delete: null},
      contatto: {label: 'Contatto', props: ['toponimo','indirizzo','civico','cap','name','provincia','email','cell', 'pec'], label_delete: null},
      indirizzo_fornitura: {label: 'Indirizzo di Fornitura', props: ['toponimo_fornitura','indirizzo_fornitura','numero_civico_fornitura','cap_fornitura','name'], label_delete: null},
      iban_contratto: {label: 'Metodo di pagamento', props: ['iban_contratto','intestazione_contratto','cf_intestazione_contratto'], label_delete: 'IBAN da eliminare'},
      cod_listino_contratto: {label: 'Offerta', props: []},
    })
    onMounted(() => { 
      Promise.all([getData()])
    })
    const setValueItem = (data, type_modifica, type_data) => {
      let el = data[type_data]
      if (type_modifica.props.length > 0) {
        let other_data_type = type_data == 'new' ? 'old' : 'new'
        
        el = JSON.parse(data[type_data])
        let other_el = JSON.parse(data[other_data_type])
        if (data.type_modifica == 'iban_contratto' && type_data == 'new' && data.request_delete) {
          return other_el.iban_contratto
        }
        if (data.type_modifica == 'iban_contratto' && type_data == 'old' && el.iban_contratto === null) {
          return 'Bollettino postale'
        }
        el = type_modifica.props.reduce((obj, prop)=>{
          if (prop == 'name') prop = 'comune'
          if (prop in el) obj[prop] = {value: el[prop], is_changed: el[prop] != other_el[prop]}
          return obj
        },{})
      }
      return el
    }
    const getData = async () => {
      loading.value = true    
      loaded.value = false       

      await service.getAllRequiredChanges()
      .then((res) => {
        Object.keys(res.items).forEach((i,items) => {   
          let is_accepted = []
          res.items[i]['modifiche'].forEach(item => {
            item.accept = true
            item.disabled = false
            if (item.request_delete && res.items[i]['admin_id'] == null) {
              item.accept = res.items[i]['cod_richiesta_firma'] == null
              item.disabled = res.items[i]['cod_richiesta_firma'] != null
            }
            
            let type_modifica = types_modifica.value[item.type_modifica]
            item.label_modifica = type_modifica.label
            item.label_delete = type_modifica.label_delete
            item.tipo_client = Number(item.tipo_client)
            item.new_setted = setValueItem(item,type_modifica,'new')
            item.old_setted = setValueItem(item,type_modifica,'old')
            if (item.new_setted && Object.entries(item.new_setted).some(([prop, obj]) => {
              const isOptionalPec = item.type_modifica === 'contatto' && item.tipo_client === 2 && prop === 'pec'
                && (item.old_setted.pec?.value == null || item.old_setted.pec.value === '')
              return obj.value === null && !isOptionalPec
            })) {
              item.accept = false
              item.disabled = true
            }
            is_accepted.push(item.accept)
          })
          
          res.items[i].is_accepted = (is_accepted.filter(el => el)).length > 0
        });
        items.value = res.items
        has_items.value = Object.keys(items.value).length ? true : false;
      })
      .finally(()=> {
        loading.value = false 
        loaded.value = true       
      })
    }

    const approvedHasItems = computed(() => Array.isArray(approvedItems.value) && approvedItems.value.length > 0)

    const formatApprovedValue = (value) => {
      if (value === null || value === undefined) {
        return '-'
      }
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value)
        } catch (e) {
          return value
        }
      }
      if (typeof value === 'object') {
        const formatValue = (entry, indentation = '') => {
          if (entry === null || entry === undefined) {
            return `${indentation}-`
          }
          if (typeof entry !== 'object') {
            return `${indentation}${entry}`
          }
          return Object.entries(entry)
            .map(([key, nested]) => {
              if (nested !== null && typeof nested === 'object') {
                return `${indentation}${key}:\n${formatValue(nested, `${indentation}  `)}`
              }
              return `${indentation}${key}: ${formatValue(nested)}`
            })
            .join('\n')
        }

        return Array.isArray(value)
          ? value.map((entry, index) => `${index}:\n${formatValue(entry, '  ')}`).join('\n')
          : formatValue(value)
      }
      return String(value)
    }

    const formatApprovedDate = (value, format = 'D-M-YYYY HH:mm:ss') => {
      if (!value) {
        return '-'
      }
      const date = moment(value)
      return date.isValid() ? date.format(format) : String(value)
    }

    const getApprovedChangeLabel = (modifica) => {
      if (modifica.type_modifica === 'delete') {
        return 'Eliminazione'
      }

      if (modifica.type_modifica !== 'iban_contratto') {
        return modifica.type_modifica
      }

      if (modifica.request_delete) {
        return 'Eliminazione iban'
      }

      try {
        const oldValue = typeof modifica.old === 'string' ? JSON.parse(modifica.old) : modifica.old
        const newValue = typeof modifica.new === 'string' ? JSON.parse(modifica.new) : modifica.new
        if (oldValue?.iban_contratto && newValue?.iban_contratto == null) {
          return 'Eliminazione iban'
        }
      } catch (e) {
        return modifica.type_modifica
      }

      return modifica.type_modifica
    }

    const loadApprovedChanges = async (page = 1) => {
      approvedLoading.value = true

      const params = { page, search: approvedSearch.value }

      await service.getApprovedChanges(params)
        .then((res) => {
          approvedItems.value = Array.isArray(res.items) ? res.items : []
          approvedTotal.value = Number(res.total) || 0
          approvedPerPage.value = Number(res.per_page) || 10
          approvedCurrentPage.value = Number(res.current_page) || page
        })
        .finally(() => {
          approvedLoading.value = false
        })
    }

    const openApprovedChangesDialog = async () => {
      showApprovedChangesDialog.value = true
      await loadApprovedChanges(1)
    }

    const searchApprovedChanges = async () => {
      if (approvedSearch.value.trim().length < 3) return
      await loadApprovedChanges(1)
    }

    const onApprovedSearchInput = async () => {
      if (!approvedSearch.value.trim()) {
        await loadApprovedChanges(1)
      }
    }

    const onApprovedPage = async (event) => {
      await loadApprovedChanges(event.page + 1)
    }

    const checkIsAccepted = (evt, i) => {
      let prop_accept = []
      Object.keys(items.value[i].modifiche).forEach(index => {
        prop_accept.push(items.value[i].modifiche[index].accept)
      })
      items.value[i].is_accepted = prop_accept.some(prop => prop)
    }
    const sendValidation = async (id_matrice, modifiche, reject = false) => {
      loading.value = true

      let data = {
        id_matrice: Number(id_matrice),
        reject: reject,
        modifiche: modifiche.map(modifica => {
          return {id: modifica.id, accept: modifica.accept}
        })
      }

      await service.sendValidation(data)
        .then(async (res)=>{
          let severity = res.items.error ? 'warn' : 'success' 
          let detail = res.items.response
          toast.add({severity:severity, summary:'', detail: detail, life:3500})
          if (res.items.error === false) {
            await getData()
            self.$eventBus.emit('modifiche-count-changed')
          }
        })
        .finally(()=> {
          loading.value = false
        })
    }

    return {
      moment,
      items,
      loading,
      loaded,
      validationErrors,
      submitted,
      currentUser,
      getData,
      layout,
      sendValidation,
      checkIsAccepted,
      has_items,
      approvedItems,
      approvedLoading,
      showApprovedChangesDialog,
      approvedSearch,
      approvedTotal,
      approvedPerPage,
      approvedCurrentPage,
      approvedHasItems,
      openApprovedChangesDialog,
      searchApprovedChanges,
      onApprovedSearchInput,
      onApprovedPage,
      formatApprovedValue,
      formatApprovedDate,
      getApprovedChangeLabel,
    }
  },
}
</script>

<style>
@media (max-width: 400px){
  .layout-main > .card{
    padding-left: unset;
  }
}

</style>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.bg-modifica,
.bg-attuale,
.bg-attuale-change,
.bg-modifica-change{
  border-radius: 5px;
}
.bg-attuale-change,
.bg-modifica-change{
  padding: 5px;
}

.bg-attuale{
  background-color:rgba(255,0,0,0.4);
  color:white;
}
.bg-attuale-change{
  background-color:rgba(255,0,0,0.9)
}
.bg-modifica{
  background-color:rgba(0,255,0,0.4)
}
.bg-modifica-change{
  background-color:rgba(0,255,0,0.9)
}
.change-box{
  min-height: 200px;
  height: auto;
}
.layout-main > .card{
  min-width: 390px !important;
  padding-right: 2rem;
}
.approved-list{
  display: grid;
  gap: 1rem;
}
.approved-search{
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.approved-search .p-inputtext{
  flex: 1;
}
.approved-card{
  min-width: 100%;
}
.approved-title{
  margin: 0 0 1rem;
  font-weight: 500;
}
.approved-meta{
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  color: #6b7280;
  font-size: 0.9rem;
}
.approved-columns-header,
.approved-layout-row{
  display: grid;
  grid-template-columns: minmax(0, 1fr) 170px minmax(0, 1fr);
  gap: 2rem;
  align-items: center;
}
.approved-columns-header{
  margin: 1rem 0 0.75rem;
  color: #233d55;
  font-size: 0.95rem;
}
.approved-columns-header > :last-child{
  text-align: right;
}
.approved-layout-row{
  margin-bottom: 1.5rem;
}
.approved-panel{
  padding: 0.9rem;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}
.approved-old{
  background: rgba(255, 0, 0, 0.4);
}
.approved-new{
  background: rgba(0, 255, 0, 0.4);
  align-items: flex-end;
  text-align: right;
}
.approved-change-tag{
  width: fit-content;
  padding: 0.35rem;
  border-radius: 3px;
  color: white;
  background: rgba(255, 0, 0, 0.9);
  font-size: 0.75rem;
}
.approved-new .approved-change-tag{
  background: rgba(0, 220, 0, 0.9);
}
.approved-empty-panel{
  min-height: 1px;
}
.approved-center{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
}
.approved-center small{
  color: #6b7280;
  white-space: nowrap;
}
.approved-change{
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
  background: #f9fafb;
}
.approved-change-row{
  display: flex;
  gap: 0.5rem;
  margin: 0.2rem 0;
  flex-wrap: wrap;
}
.approved-value{
  margin: 0;
  width: 100%;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: inherit;
  flex: 1;
}
.approved-label{
  min-width: 70px;
  color: #374151;
}
@media (max-width: 700px){
  .approved-columns-header,
  .approved-layout-row{
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .approved-columns-header > :last-child{
    text-align: left;
  }

  .approved-new{
    align-items: flex-start;
    text-align: left;
  }

  .p-column-header-content .p-column-title{
    font-size: 1vw;
  }

  .layout-main > .card{
    padding-left: unset;
  }
}
.btn-filter{
  /* font-size: 0.7rem !important; */
  aspect-ratio: 4/1.1;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.btn-filter:hover {
  opacity: 1;
}
.btn-filter .p-button-label{
  font-size: 1em;
  line-height: 1em;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  text-overflow: ellipsis;
}

.btn-filter.selected {
  opacity: 1;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  box-shadow: none;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.btn-downloads-matrici {
  position:fixed;
  bottom:60px; 
  right:40px;
  z-index:2;
}
.nota{
  border-bottom: 1px solid #6c757d3d;
  margin-bottom: 10px;
}
</style>
